import actionTypePrefixes from "../../actions/actionTypePrefixes"

const initialState = {
  isLoading: true,
  loadingFailed: false,
  widgets: {
    goalStatusBreakdown: {
      data: null,
      subtitle: null,
    },
    overallBehaviourAverage: {
      data: null,
      subtitle: null,
    },
    goalScore: {
      data: null,
      subtitle: null,
    },
    valueAlignment: {
      data: null,
      subtitle: null,
    },
    performanceScore: {
      data: null,
      subtitle: null,
    },
    behavioursBreakdown: {
      data: null,
      subtitle: null,
    },
    nineBoxGridSummary: {
      data: null,
      subtitle: null,
    },
    nineBoxGridDrilldown: {
      data: null,
      subtitle: null,
    },
  },
}

export default function performanceAndProgressionReducer(state = initialState, action) {
  if (action.type.indexOf(actionTypePrefixes.PerformanceAndProgression) !== 0) {
    return state
  }

  const actionType = action.type.replace(actionTypePrefixes.PerformanceAndProgression, "")

  switch (actionType) {
    case "LOAD_9BG_DRILLDOWN_BOX":
      return {
        ...state,
        widgets: {
          ...state.widgets,
          nineBoxGridDrilldown: { data: null, subtitle: null },
        },
      }
    case "LOAD_9BG_DRILLDOWN_BOX_FAIL":
      return state
    case "LOAD_9BG_DRILLDOWN_BOX_SUCCESS":
      return {
        ...state,
        widgets: {
          ...state.widgets,
          nineBoxGridDrilldown: action.payload.data,
        },
      }
    case "LOAD_9BG_DRILLDOWN":
      return state
    case "LOAD_9BG_DRILLDOWN_FAIL":
      return state
    case "LOAD_9BG_DRILLDOWN_SUCCESS":
      return {
        ...state,
        widgets: {
          ...state.widgets,
          nineBoxGridDrilldown: action.payload.data,
        },
      }
    case "LOAD_DASHBOARD_DATA":
      return {
        ...state,
        errorMessageKey: null,
        isLoading: true,
        loadingFailed: false,
        widgets: {
          goalStatusBreakdown: {
            data: null,
            subtitle: null,
          },
          overallBehaviourAverage: {
            data: null,
            subtitle: null,
          },
          goalScore: {
            data: null,
            subtitle: null,
          },
          valueAlignment: {
            data: null,
            subtitle: null,
          },
          performanceScore: {
            data: null,
            subtitle: null,
          },
          behavioursBreakdown: {
            data: null,
            subtitle: null,
          },
          nineBoxGridSummary: {
            data: null,
            subtitle: null,
          },
          nineBoxGridDrilldown: {
            data: null,
            subtitle: null,
          },
        },
      }

    case "LOAD_DASHBOARD_DATA_SUCCESS":
      // Mocked below...waiting for real data to come in via `action.payload.data`
      return {
        ...state,
        errorMessageKey: null,
        isLoading: false,
        loadingFailed: false,
        widgets: {
          ...state.widgets,
          goalStatusBreakdown: action.payload.data.goalStatusBreakdown,
          overallBehaviourAverage: action.payload.data.behavioursAverage,
          goalScore: action.payload.data.goalScore,
          valueAlignment: action.payload.data.valueAlignment,
          performanceScore: action.payload.data.performanceScore,
          behavioursBreakdown: action.payload.data.behavioursBreakdown,
          nineBoxGridSummary: action.payload.data.nineBoxGrid,
          nineBoxGridDrilldown: {
            data: null,
          },
        },
      }
    case "LOAD_DASHBOARD_DATA_FAIL":
      return {
        ...state,
        errorMessageKey: "Dashboards.ErrorMessages.ApiError",
        isLoading: false,
        loadingFailed: true,
        widgets: {
          ...state.widgets,
          goalStatusBreakdown: { data: null, subtitle: null },
          overallBehaviourAverage: { data: null, subtitle: null },
          goalScore: { data: null, subtitle: null },
          valueAlignment: { data: null, subtitle: null },
          performanceScore: { data: null, subtitle: null },
          behavioursBreakdown: { data: null, subtitle: null },
          nineBoxGridSummary: { data: null, subtitle: null },
          nineBoxGridDrilldown: { data: null, subtitle: null },
        },
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/state/reducers/dashboards/performanceAndProgressionReducer.js